<template>
    <div class="iconCom"
         :style="{lineHeight: trans.height + 'px'}" @click="getbtnClick">
        <i class="iconfont"
           :class="config.name"
           @mouseover="svgColor=config.hoverColor"
           @mouseout="svgColor=config.color"
           :style="{
           fontSize:trans.width > trans.height ? trans.height*3/4 + 'px' : trans.width*3/4 +'px',
           color:svgColor,
           transform: config.transform.type==='rotate'?'rotate('+config.transform.rotate +'deg)':config.transform.flipVertically?config.transform.flipHorizontally?'scaleX(-1) scaleY(-1)':'scaleY(-1)':config.transform.flipHorizontally?'scaleX(-1)':'',
           }"
        ></i>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/5/26 3:57 下午
     */
    import {pathFullScreen} from '@/assets/js/basis.js'
    export default {
        name: 'iconCom',
        components: {},
        props: {
            id: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
             option: {
                type: Object,
                default: ''
            },
            trans: {
                type: Object,
                default: {}
            }
        },
        data() {
            return {
                svgColor: '#fff',
            }
        },
        computed: {
           config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.option.setting.params;
                }
            },
        },
        methods: {
            getbtnClick(){
                if(this.$route.path.indexOf('/fullScreen')!==-1){
                    pathFullScreen({
                        id:this.config.push.url,
                        type:1
                    })
                }
            },
        },
        watch: {
            config(a) {
                this.svgColor = a.color;
            }
        },
        mounted() {
        },
        destroyed() {

        }
    }
</script>

<style lang="less">
    @import "../../../iocnfont/iconfont.css";

    .iconCom {
        width: 100%;
        height: 100%;
        position: relative;
        text-align: center;

        > i {
            display: inline-block;
        }
    }
</style>
